var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-text-section',{staticClass:"basic-text-section-module",attrs:{"content":_vm.attributes.basicText_content,"centered":_vm.attributes.basicText_centered,"container-width":_vm.attributes.container_width}})}
var staticRenderFns = []

export { render, staticRenderFns }